export const JWT_PAYLOAD_MISSING_ERROR =
  "The JWT structure is not valid. A payload object is expected to be present at the root of the JWT, containing all of the Trust Payments fields, e.g. locale.";

export class JwtValidationError extends Error {
  constructor(
    message: string,
    public readonly originalError?: unknown,
  ) {
    super(message);
    this.name = "JwtValidationError";
    Object.setPrototypeOf(this, JwtValidationError.prototype);
  }
}
